/**
 * 战斗工具函数
 * 提供战斗模块中常用的工具函数，减少重复代码
 */

import UIStyleHelper from '../UIStyleHelper.js';

/**
 * 检查是否是当前队员的回合
 * @param {boolean} isTeamBattle - 是否是组队模式
 * @param {Array} teamMembers - 队伍成员数组
 * @param {number} currentTeamMemberIndex - 当前队员索引
 * @param {string|null} localPlayerId - 本地玩家ID（可选，如果有网络管理器）
 * @returns {Object} { isMyTurn: boolean, currentMember: Object|null, isLocalPlayer: boolean }
 */
export function checkIfMyTurn(isTeamBattle, teamMembers, currentTeamMemberIndex, localPlayerId = null) {
    if (!isTeamBattle || teamMembers.length === 0) {
        return {
            isMyTurn: true,
            currentMember: null,
            isLocalPlayer: true
        };
    }
    
    const currentMember = teamMembers[currentTeamMemberIndex];
    if (!currentMember) {
        return {
            isMyTurn: false,
            currentMember: null,
            isLocalPlayer: false
        };
    }
    
    // 判断是否是本地玩家的回合
    const networkManager = window.networkManager;
    let isMyTurn = false;
    let isLocalPlayer = false;
    
    if (localPlayerId !== null) {
        // 如果提供了本地玩家ID，直接比较
        isLocalPlayer = currentMember.playerId === localPlayerId;
        isMyTurn = isLocalPlayer;
    } else if (networkManager) {
        // 如果有网络管理器，使用网络管理器的玩家ID
        isLocalPlayer = currentMember.playerId === networkManager.playerId;
        isMyTurn = isLocalPlayer;
    } else {
        // 如果没有网络管理器，默认第一个是本地玩家
        isLocalPlayer = currentTeamMemberIndex === 0;
        isMyTurn = isLocalPlayer;
    }
    
    return {
        isMyTurn,
        currentMember,
        isLocalPlayer
    };
}

/**
 * 检查点击是否在矩形区域内
 * @param {number} clickX - 点击X坐标
 * @param {number} clickY - 点击Y坐标
 * @param {number} rectX - 矩形X坐标
 * @param {number} rectY - 矩形Y坐标
 * @param {number} rectWidth - 矩形宽度
 * @param {number} rectHeight - 矩形高度
 * @returns {boolean} 是否在区域内
 */
export function isClickInRect(clickX, clickY, rectX, rectY, rectWidth, rectHeight) {
    return clickX >= rectX && 
           clickX <= rectX + rectWidth && 
           clickY >= rectY && 
           clickY <= rectY + rectHeight;
}

/**
 * 应用选中项高亮样式
 * @param {Phaser.GameObjects.Text} text - 文本对象
 * @param {boolean} isSelected - 是否选中
 * @param {boolean} isAvailable - 是否可用（用于颜色选择）
 */
export function applySelectionHighlight(text, isSelected, isAvailable = true) {
    if (isSelected) {
        text.setFill(isAvailable ? UIStyleHelper.MENU_COLORS.SELECTED : UIStyleHelper.TEXT_STYLES.ERROR.fill);
        text.setScale(1.1);
    } else {
        text.setFill(UIStyleHelper.MENU_COLORS.NORMAL);
        text.setScale(1.0);
    }
}

